import styled, { Scale } from '@secretescapes/falcon';

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${Scale.xxs};
  height: 100vh;
  @supports (height: 100dvh) {
    height: 100dvh;
  }
  width: 100vw;
  background-color: ${({ theme }) => theme.color.white};
`;

export const Header = styled('div')`
  display: flex;
  justify-content: flex-end;
`;
